import Tooltip from "./tooltip.directive";

export default angular
    .module("oui.tooltip", [])
    .directive("ouiTooltip", Tooltip)
    .name;
